
import { Messages } from '../../../../codegen/Localize';
import { ConnectionEditabilityHelper } from '../../../../connectivity/services/EditConnectionDialog';
import { getCommonDatasourceInfo } from '../../../../datasource/models/mappers/CommonDatasourceInfo';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IDataConnectionInfo } from '../../../../ts/models/IDataConnectionInfo';
import { editDataConnections } from '../../../actions/spaces/EditConnectionAction';
import { selectSpaceInfo } from '../../../selectors/SpaceInfoSelectors';
import { AppState } from '../../../state/AppState';
import { SpaceInfo } from '../../../state/SpaceInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const EditDataConnectionsAction: IEntityAction<IContentInfo<'datasource' | 'dataconnection'>, {}> = {
  name: EntityActionNames.EditDataConnection,
  translateName: Messages.editConnection_action,
  isVisible: (targetItems: IContentInfo<'datasource' | 'dataconnection'>[], state: AppState) => {
    // Hide the edit connections from the datasource masthead. To avoid confusion
    // force the user to explicitly select the connections to edit in the Connections subplace.
    const spaceInfo: SpaceInfo = selectSpaceInfo(state);
    if (targetItems.length === 1 && targetItems[0].contentType === 'datasource') {
      return spaceInfo.spaceType !== 'datasource';
    }
    return true;
  },
  isClickable: (availableActions: {}, content: IContentInfo<'datasource' | 'dataconnection'>[], state: AppState) => {
    if (content.length > 1) {
      return true; // Eagerly try to edit if we have more than one item
    } else if (content[0].contentType === 'datasource') {
      // Grab only the common fields because we don't know which API the data source came from
      const commonDatasource = getCommonDatasourceInfo(content[0]);
      if (commonDatasource.connectionType === 'publishedConnection') {
        return false;
      }
      return ConnectionEditabilityHelper.userCanEditDatasource(commonDatasource, state);
    } else if (content[0].contentType === 'dataconnection') {
      // We don't get data connections through mixed content, so it's safe to say it's a IDataConnectionInfo
      const dataConnection = content[0] as IDataConnectionInfo;
      return ConnectionEditabilityHelper.userCanEditConnection(dataConnection, state);
    } else {
      return false;
    }
  },
  createReduxAction: (dataSourcesOrConnections: IContentInfo[]) => editDataConnections(dataSourcesOrConnections)
};
